<script>
export default {
  provide() {
    return { parentValidator: this.$validator }
  },
}
</script>
